





























import { Component, Prop } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import InputGroup from '@/mixins/form/inputGroup'

type InputType = {
  value: number
  label: string
}
type InputListType = Array<InputType>

@Component({
  components: {
    CheckboxInput: () => import('@/components/common/inputs/CheckboxInput.vue')
  }
})
export default class PdTabSettingModalQualityInputGroup extends mixins(
  InputGroup
) {
  @Prop({ type: Object, required: true }) inputs!: {
    emg: InputListType
    warn: InputListType
  }
  @Prop({ type: String, required: true }) title!: string
}
